<template>
    <v-list color="accent" nav>
        <MenuBannerUser :rail="rail" @mini_switch="rail = !rail" />
        <v-divider></v-divider>
        <v-list-item :prepend-icon="item.icon" v-for="item in items" :key="item.title" link :to="{ name: item.to }">
            <v-list-item-title>{{ item.title }}</v-list-item-title>
            <template v-if="item.beta" v-slot:append>
                <v-chip color="warning" size="x-small" variant="tonal" label>PREVIEW</v-chip>
            </template>
        </v-list-item>
    </v-list>
</template>

<script>
import MenuBannerUser from './account/MenuBannerUser.vue';
import { useSessionStore } from '@/stores/session';
import { computed, watch, onMounted } from 'vue';

export default {
    components: { MenuBannerUser },
    setup() {
        const sessionStore = useSessionStore();

        // Computed properties to determine user type
        const isExternalCustomer = computed(() => sessionStore.is_external_customer);
        const isExternalWorkshop = computed(() => sessionStore.is_external_workshop);
        const hasAdminPrivileges = computed(() => sessionStore.has_admin_privileges);

        // Function to print menu information in the console
        const logMenuInfo = () => {
            console.log('=== NAVIGATION MENU INFORMATION ===');
            console.log(`Is external customer: ${isExternalCustomer.value}`);
            console.log(`Is external workshop: ${isExternalWorkshop.value}`);
            console.log(`Has admin privileges: ${hasAdminPrivileges.value}`);

            let menuType = 'Internal user (full menu)';
            if (isExternalCustomer.value) {
                menuType = 'External customer (Dashboard + Orders + Shipments)';
            } else if (isExternalWorkshop.value) {
                menuType = 'External workshop (WO + Shipments)';
            }

            console.log(`Menu type displayed: ${menuType}`);
            console.log(`Admin option visible: ${hasAdminPrivileges.value || (!isExternalCustomer.value && !isExternalWorkshop.value)}`);
            console.log('=========================================');
        };

        // Execute the log when the user type changes
        watch([isExternalCustomer, isExternalWorkshop, hasAdminPrivileges], () => {
            logMenuInfo();
        });

        // Execute the log when the component is mounted
        onMounted(() => {
            // Wait a moment to ensure user data is loaded
            setTimeout(logMenuInfo, 1500);
        });

        // Computed property for menu items based on user type
        const items = computed(() => {
            // Items for external customers
            if (isExternalCustomer.value) {
                return [
                    { title: 'Dashboard', icon: 'mdi-view-dashboard', to: "customer_dashboard" },
                    { title: 'Orders', icon: 'mdi-package-variant', to: "customer_rso" },
                    { title: 'Shipments', icon: 'mdi-airplane', to: "customer_shipment" },
                    { title: 'Components', icon: 'mdi-cog', to: "customer_components" },
                    { title: 'My Account', icon: 'mdi-account', to: "customer_account" },
                    { title: 'Logout', icon: 'mdi-logout', to: "logout" },
                ];
            }

            // Items for external workshops
            else if (isExternalWorkshop.value) {
                return [
                    { title: 'Work Orders', icon: 'mdi-hammer-screwdriver', to: "wo" },
                    { title: 'Shipments', icon: 'mdi-airplane', to: "workshop_shipment" },
                    { title: 'My Account', icon: 'mdi-account', to: "account" },
                    { title: 'Logout', icon: 'mdi-logout', to: "logout" },
                ];
            }

            // Items for internal users (default)
            else {
                const internalItems = [
                    { title: 'Refurbishment Sales Orders', icon: 'mdi-file-document-outline', to: "rso" },
                    { title: 'Work Orders', icon: 'mdi-hammer-screwdriver', to: "wo" },
                    { title: 'Shipments — OFC', icon: 'mdi-airplane', to: "shipment" },
                    { title: 'WH Intake Rotterdam', icon: 'mdi-warehouse', to: "shipment_warehouse", beta: true },
                    { title: 'Containers', icon: 'mdi-train-car-container', to: "container" },
                    { title: 'Part Numbers', icon: 'mdi-wind-turbine', to: "partnumber" },
                ];

                // Mostrar opciones de Admin solo si el usuario tiene privilegios de administrador
                if (hasAdminPrivileges.value) {
                    internalItems.push({ title: 'CO2 Config', icon: 'mdi-molecule-co2', to: "co2_config" });
                    internalItems.push({ title: 'Admin', icon: 'mdi-account-group-outline', to: "admin" });
                }

                internalItems.push({ title: 'My Account', icon: 'mdi-account', to: "account" });
                internalItems.push({ title: 'Logout', icon: 'mdi-logout', to: "logout" });

                return internalItems;
            }
        });

        return {
            rail: true,
            items,
            isExternalCustomer,
            isExternalWorkshop,
            hasAdminPrivileges
        };
    }
}
</script>
